'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {isEqual} from 'underscore';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import ProgressBar from "react-bootstrap/ProgressBar";
import Table from "react-bootstrap/Table";

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import {isFalse, isTrue, isEmpty} from '@uw-it-sis/lib-react/lib/Utils';
import TermUtils from "@uw-it-sis/lib-react/lib/TermUtils";

import {buildRegistrationSlnList, buildRegistrationUrl} from '@uw-it-sis/lib-react-myplan/lib/RegistrationUtils';

import registerStore from "./RegisterStore";
import RegisterResult from "./RegisterResult";
import registrationDetailsStore from './RegistrationDetailsStore';
import RegistrationFailure from "./RegistrationFailure";
import {NextAction, PlanItemType} from "../lib/Constants";

class Register extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = registerStore;
        this.analyticsStore = appStore.getAnalyticsStore();
    }

    componentDidMount() {
        this.store.mount(this.props.termId);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(prevProps, this.props)) {
            this.store.mount(this.props.termId);
        }
    }

    submitRegistration = () => {
        const dataStateSummary = registrationDetailsStore.getCurrentDataStateSummary();
        const selectedCount = registrationDetailsStore.getSelectedRegistrationItemsCount();
        let additionalData = {
            regdCnt: dataStateSummary.registeredCount,
            cIssuesCnt: dataStateSummary.courseIssuesCount,
            sIssuesCnt: dataStateSummary.sectionIssuesCount,
            readyCnt: dataStateSummary.readyCount,
            holdsCnt: dataStateSummary.holdsCount,
            regDate: dataStateSummary.registrationDate,
            selCnt: selectedCount,
            isSeamless: `true`
        }
        this.analyticsStore.addEvent("RegPrev-RegButtonClick",{}, additionalData);

        this.store.submitRegistration();
    }

    handleClose = () => {
        this.store.closeModal();
        this.props.onSuccess();
    }

    render() {
        let modalComponent, modalTitle, modalBody, modalClose, buttonComponent, buttonLabel, buttonDisabled, buttonClickHandle;

        modalTitle = "Registration";
        buttonLabel = "Send to Registration";
        buttonDisabled = true;
        buttonClickHandle = () => {};

        switch (this.store.state) {
            case States.initial:
                modalClose = true;
                break;
            case States.pending:
                buttonLabel =
                    <>
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2 align-middle"
                        />
                        <span className="align-middle">Send to Registration</span>
                    </>
                modalTitle = "Attempting To Register You For Your Sections"
                modalBody =
                    <>
                        <p>MyPlan is attempting to register you for your sections.</p>
                        <p>Please wait...</p>
                    </>
                modalClose = false;
                break;
            case States.error:
                modalTitle = "Registration Was Unsuccessful"
                modalBody = <RegistrationFailure isWithinModal />
                modalClose = true;
                break;
            default:
                buttonDisabled = appStore.isAdviser() || registrationDetailsStore.isEmpty(PlanItemType.planned) || isFalse(this.store.hasChanges());
                buttonClickHandle = this.submitRegistration;
                if (!isEmpty(this.store.result) && this.store.result.hasOwnProperty("nextAction")) {
                    switch (this.store.result.nextAction) {
                        case NextAction.FAIL:
                            modalTitle = "Registration Was Unsuccessful";
                            break;
                        case NextAction.SUCCESS:
                            modalTitle = "Registration Was Successful";
                            break;
                    }
                    modalBody = <RegisterResult result={this.store.result} />
                }
                modalClose = true;
                break;
        }

        if (this.store.showModal) {
            let modalFooter;
            if (modalClose) {
                modalFooter =
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>Close and Refresh</Button>
                    </Modal.Footer>
            }
            modalComponent =
                <Modal show={this.store.showModal}
                       onHide={this.handleClose}
                       size="lg"
                       backdrop="static"
                       aria-labelledby="modal-register-title"
                       centered
                       aria-live="polite"
                       aria-atomic={true}>
                    <Modal.Header closeButton={modalClose}>
                        <Modal.Title as="h3" id="modal-register-title" aria-live="polite" aria-atomic={true}>{modalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {modalBody}
                    </Modal.Body>
                    {modalFooter}
                </Modal>
        }

        buttonComponent =
            <Button id="submit-registration"
                    disabled={buttonDisabled}
                    aria-disabled={buttonDisabled}
                    onClick={buttonClickHandle}>
                {buttonLabel}
            </Button>

        return (
            <>
                {buttonComponent}
                {modalComponent}
            </>
        )
    }
}

Register.propTypes = {
    termId: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
    selectionCount: PropTypes.number.isRequired
}

export default observer(Register);